import setVar from './util/setVar';
import { ReportConfigInterface } from './ReportConfig';

export default class ToggleConfig {
  eventTitle: boolean;
  internalIp: boolean;
  machineName: boolean;
  machineUser: boolean;
  o365Oid: boolean;
  o365UniqueUserDigest: boolean;
  userEmail: boolean;

  constructor(obj?: ToggleConfig, config?: ReportConfigInterface) {
    this.eventTitle = setVar(true, obj && obj.eventTitle, config && config.svt);
    this.internalIp = setVar(true, obj && obj.internalIp);
    this.machineName = setVar(false, obj && obj.machineName);
    this.machineUser = setVar(false, obj && obj.machineUser);
    this.o365Oid = setVar(false, obj && obj.o365Oid);
    this.o365UniqueUserDigest = setVar(false, obj && obj.o365UniqueUserDigest);
    this.userEmail = setVar(false, obj && obj.userEmail);
  }
}
